import { i18n } from '@/lib/i18n'

/** Các biến tham số có thể chèn vào nội dung tin nhắn hàng loạt. */
export const THE_BIEN_THAM_SO = [
  { bien: '{{ten}}', get nhan() { return i18n.t('marketing:broadcastVars.firstName') }, vd: 'An' },
  { bien: '{{ho_ten}}', get nhan() { return i18n.t('marketing:broadcastVars.fullName') }, vd: 'Nguyễn Văn An' },
  { bien: '{{sdt}}', get nhan() { return i18n.t('marketing:broadcastVars.phone') }, vd: '0901234567' },
] as const

/** Chèn `bien` vào vị trí con trỏ (hoặc thay đoạn đang bôi đen); trả về nội dung mới và vị trí con trỏ sau khi chèn. */
export function chenTaiConTro(
  noiDung: string, bien: string, batDau: number | null, ketThuc: number | null,
): { noiDung: string; conTro: number } {
  const a = Math.max(0, Math.min(batDau ?? noiDung.length, noiDung.length))
  const b = Math.max(a, Math.min(ketThuc ?? a, noiDung.length))
  return { noiDung: noiDung.slice(0, a) + bien + noiDung.slice(b), conTro: a + bien.length }
}
